import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DropdownHeader = (props) => {
    const { icon, label, center = true, className = '' } = props;
    return (_jsx("li", { className: `dropdown-header ${center ? 'center' : ''} ${className}`, children: _jsxs("span", { className: 'dropdown-header-text', children: [icon && _jsx("span", { className: 'margin-right-5', children: icon }), label] }) }));
};
export default DropdownHeader;
